module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/porsche-fdb9ddbc634c553fd5767ce93aaa8de5.png";